var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Service from "./Service.js";
class Load extends Service {
  constructor() {
    super(...arguments);
    __publicField(this, "props", {
      time: window.performance.now()
    });
  }
  init() {
    window.addEventListener("load", this);
  }
  handleEvent() {
    this.updateProps();
    this.trigger(this.props);
  }
  kill() {
    window.removeEventListener("load", this);
  }
  updateProps() {
    this.props.time = window.performance.now();
    return this.props;
  }
}
let instance;
let load;
function useLoad() {
  if (!load) {
    if (!instance) {
      instance = new Load();
    }
    load = {
      add: instance.add.bind(instance),
      remove: instance.remove.bind(instance),
      has: instance.has.bind(instance),
      props: instance.updateProps.bind(instance)
    };
  }
  return load;
}
export {
  useLoad as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
